import React from 'react';
import MobileGameIcon from '../../assets/svg/common/default-game.svg';
import ConsoleGameIcon from '@/pages/home/assets/img/common/consolegame-default.png';
import SvgIcon from '@home/components/SvgIcon';
import { Bubble } from 'tea-component';
import classNames from 'classnames';
import { FRAME_TYPE_MAP } from '../../_config/constant';
import { getCountryFlag } from '@home/_config/countries';
import { getBasePath } from '@/utils/utils';
import BasicImage from '@home/components/BasicImage';

// 获取国家图标
const getCountryIcon = (country: string) => {
  let imgDom;
  try {
    imgDom = (
      <img
        src={getCountryFlag(country === 'Total' ? 'Global' : country)}
        alt="flag"
      />
    );
  } catch (error) {
    imgDom = <img src={getCountryFlag('undefined')} alt="flag" />;
  }
  return imgDom;
};

// 国家列
const CountryRender = ({ value, name }: { value: string; name: string; }) => (
  <div className="dbb-table-country-column">
    {getCountryIcon(value)}
    <div>{name}</div>
  </div>
);

// 游戏列
const GameRender = ({ data, frameType }: any) => {
  const {
    cover,
    pc_id,
    console_id,
    mobile_id,
    publisher_country,
    game_name,
    publisher,
    combined_id,
    game_id,
  } = data;

  // 打开情报详情新窗口
  const linkGameDetail = () => {
    window.open(
      `${getBasePath()}/intelligence/topCharts/${isPc ? 'pcConsoleGames' : 'mobileGames'
      }/gamesDetails/${combined_id || game_id}/stats/allMetrics`,
      '_blank',
    );
  };

  const isPc = frameType === FRAME_TYPE_MAP.pcconsole;
  return (
    <div className="dbb-table-game-column" style={{ height: isPc ? 46 : 40 }}>
      <div
        className={classNames('dbb-table-game-column-left', {
          'is-pc': isPc,
        })}
      >
        <BasicImage src={cover} errorSrc={isPc ? ConsoleGameIcon : MobileGameIcon} />
      </div>
      <div className="dbb-table-game-column-right">
        <div
          className="dbb-table-game-column-right-top"
          onClick={linkGameDetail}
        >
          <Bubble arrowPointAtCenter placement="top-end" content={game_name}>
            {game_name}
          </Bubble>
        </div>
        <div className="dbb-table-game-column-right-bottom">
          <div className="dbb-table-game-column-right-bottom-platform">
            {pc_id && <SvgIcon type={'a-ziyuan2'} />}
            {console_id && <SvgIcon type={'a-console2'} />}
            {mobile_id && <SvgIcon type={'Mobile'} className="" />}
          </div>
          <div className="dbb-table-game-column-right-bottom-line"></div>
          <div
            className={classNames(
              'dbb-table-game-column-right-bottom-country',
              { 'is-pc': isPc },
            )}
          >
            {getCountryIcon(publisher_country)}
            <div>
              <Bubble
                arrowPointAtCenter
                placement="top-end"
                content={publisher}
              >
                {publisher}
              </Bubble>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { GameRender, CountryRender };
